import { nextErrorFragment, orderFragments } from 'next-common';

export const toggleVehicleAccessoriesOnOrderMutation = `
  mutation toggleVehicleAccessoriesOnOrder(
    $orderId: ID!
    $addAccessories: [VehicleAccessoryInput!]
    $removeAccessories: [VehicleRemoveAccessoryInput!]
    $orderInput: OrderInput
  ) {
    toggleVehicleAccessoriesOnOrder(
      orderId: $orderId
      addAccessories: $addAccessories
      removeAccessories: $removeAccessories
      orderInput: $orderInput
    ) {
      ...order
      ...nextError
    }
  }
  ${orderFragments}
  ${nextErrorFragment}
`;
